import React from 'react';
import { Route, NavLink, Switch, withRouter } from "react-router-dom";
import { withAuth0 } from "@auth0/auth0-react";
import { Nav, UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu } from 'reactstrap';
import "./Nav.css";
import Demographics from '../../pages/demographics/Demographics';
import CompareDemographics from '../../pages/demographics/CompareDemographics';
import MasterChildDemographics from '../../pages/demographics/MasterChildDemographics';
import BusinessDemographics from '../../pages/businessDemographics/BusinessDemographics';
import AdvancedSearch from '../../pages/advancedSearch/AdvancedSearch';
import Utilities from '../../pages/utilities/Utilities';
import SystemConfiguration from '../../pages/utilities/SystemConfiguration.js';
import SSRSReports from '../../pages/reports/SSRSReports.js';
import CRMReports from '../../pages/reports/CRMReports.js';
import CRMCustomReports from '../../pages/reports/CRMCustomReports.js';
import SECReports from '../../pages/reports/SECReports.js';
import SECReportsDetail from '../../pages/reports/SECReportsDetail.js';
import SalesOpportunitiesAdmin from '../../pages/salesOpportunitiesAdmin/SalesOpportunitiesAdmin';
import Admin from '../../pages/admin/Admin';
import Profile from '../../pages/profile/Profile';
import Marketing2 from '../../pages/marketing/Marketing2';
import Landing from '../../pages/landing/Landing';
import ProtectedRoute from "../../auth/protected-route.js";
import AuthenticationButton from "../AuthenticationButton/AuthenticationButton";
import Autocomplete from '../../components/Autocomplete/Autocomplete.js';
import PermissionWrapper from '../../auth/PermissionWrapper';
import Companies from '../../pages/companies/Companies.js';
import Contacts from '../../pages/contacts/Contacts.js';
import Contacts2 from '../../pages/contacts/Contacts2.js';
import DashboardTiles from '../../pages/dashboardTiles/DashboardTiles.js';
import CompanyContext from '../../auth/CompanyContext.js';
import CRMContext from '../../auth/CRMContext.js';

class NavMenu extends React.Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.state = {
            companySettings: {},
            companySettingsLoaded: false,
            opportunitiesTags: [],
            opportunitiesTagsLoaded: false,
            statuses: []
        };
    }

    componentDidMount = () => {
        this.getCompanySettings();
        this.getOpportunitiesTags();
    }

    onSelectAutocomplete = (val) => {
        // console.log(val);
    }

    getOpportunitiesTags = () => {
        fetch('/api/opportunitiesTags/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    opportunitiesTags: results.data.filter(item => item.PrimaryCategory).map(item => item.Tag),
                    opportunitiesTagsLoaded: true,
                });
            });
    }

    getMyFavorites = () => {
        // console.log('Nav.js/getMyFavorites()')
        fetch('/api/favorites/' + this.props.user, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if ("data" in results) {
                    this.setState(
                        {
                            favorites: results.data,
                        }
                    )
                }
            });
    }

    getCompanySettings = () => {
        // console.log('Nav.js/getMyFavorites()')
        if (!this.props.database) return;
        fetch('/api/systemCompanies/' + this.props.database, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if ("data" in results) {
                    this.setState(
                        {
                            companySettings: results.data?.[0],
                            companySettingsLoaded: true,
                        }
                    )
                }
            });
    }

    addFavorite = (type, favorite) => {
        // console.log('Nav.js/addFavorite()')
        fetch('/api/favorites/', {
            method: 'POST',
            body: JSON.stringify({
                auth0: this.props.user,
                type: type,
                favorite: favorite
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getMyFavorites();
                }
            });
    }

    removeFavorite = (type, favorite) => {
        // console.log('Nav.js/removeFavorite()')
        fetch('/api/favorites/' + this.props.user + '/' + type + '/' + favorite, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getMyFavorites();
                }
            });
    }

    checkPermission = (permission) => {
        // console.log('Nav.js/checkPermission(permission)', permission)
        const permissionGranted =
            permission === '' || permission == null ||
            this.props.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
        return permissionGranted;
    }

    renderLanding = (routeProps) => <Landing {...routeProps} {...this.props} companySettings={this.state.companySettings} />;
    renderCompanies = (routeProps) => <Companies {...routeProps} {...this.props} />;
    renderContacts = (routeProps) => <Contacts {...routeProps} {...this.props} />;
    renderAutocomplete = (routeProps) => (
        <Autocomplete
            {...routeProps}
            clientToken={this.props.clientToken}
            available_dates={this.props.available_dates} /* ... */
            newPage={true}
            onSelect={this.onSelectAutocomplete}
            enableHistory={true}
            clearOnSelect={true}
        />
    );

    render() {
        const { isAuthenticated, user } = this.props.auth0;
        const { nickname } = user || {};
        const { pathname } = this.props.location;
        const isCallback = pathname === "/callback";
        const useSECData = this.props.database === 'SecReporting';

        const ready =
            isAuthenticated &&
            this.props.user !== 0 &&
            this.props.userPermissions.length > 0 &&
            this.state.opportunitiesTagsLoaded &&
            this.state.companySettingsLoaded;
        return (
            <>
                <Nav className="Nav nav-container">
                    <div className="nav-left d-flex align-items-center">
                        {this.state.companySettings.CompanyLogo && (
                            <NavLink exact className="navbar__link" to="/">
                                <img
                                    src={`data:image/png;base64,${this.state.companySettings.CompanyLogo}`}
                                    alt="Company Logo"
                                    className='companyLogo'
                                    style={{ height: '40px', marginRight: '1rem' }}
                                />
                            </NavLink>
                        )}

                        <div className="autocompleteContainer">
                            {!isCallback && <Route path="/" render={this.renderAutocomplete} />}
                        </div>
                    </div>

                    <div className="nav-right d-flex align-items-center ml-auto">
                        {!isAuthenticated && (
                            // <nav className="Nav">
                            <AuthenticationButton />
                            //  </nav>
                        )}

                        {isAuthenticated && !ready && (
                            <span className="text-muted ml-2">Loading…</span>
                        )}

                        {ready && (
                            <>
                                {/* ALL existing authenticated nav links */}
                                <NavLink exact className="navbar__link" to="/">Home</NavLink>

                                <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret className="navbar__link">Search</DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem tag={NavLink} to="/companies" className="navbar__link">Companies</DropdownItem>
                                        <DropdownItem tag={NavLink} to="/search" className="navbar__link">Advanced Company Search</DropdownItem>
                                        <DropdownItem tag={NavLink} to="/contacts" className="navbar__link">Contacts</DropdownItem>
                                        {this.state.opportunitiesTags?.map(opportunityTag => (
                                            <DropdownItem key={opportunityTag} tag={NavLink} to={`/${opportunityTag.toLowerCase().replaceAll(' ', '-')}`} className="navbar__link">{opportunityTag}</DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </UncontrolledDropdown>

                                <PermissionWrapper {...this.props} allowedPermission={["Workflows"]} hidden={true}>
                                    <NavLink exact className="navbar__link" to="/marketing">Workflows</NavLink>
                                </PermissionWrapper>

                                <CRMContext.Consumer>
                                    {crmCtx => {
                                        const showBusinessDemographics = useSECData && this.checkPermission('Business Demographics Graph');
                                        const showCRMReports = crmCtx?.crmEnabled === true && this.checkPermission('CRM Integration');
                                        const showSECReports = this.state.companySettings?.CompanyUseSECData && this.checkPermission('Reports');
                                        if (!showBusinessDemographics && !showCRMReports && !showSECReports) return null;
                                        return (
                                            <UncontrolledDropdown nav inNavbar>
                                                <DropdownToggle nav caret className="navbar__link">Utilities</DropdownToggle>
                                                <DropdownMenu className="dropdown-menu-right-fix">
                                                    {showBusinessDemographics && (
                                                        <DropdownItem tag={NavLink} to="/business-demographics" className="navbar__link">Business Demographics</DropdownItem>
                                                    )}
                                                    {showCRMReports && (
                                                        <>
                                                            <DropdownItem tag={NavLink} to="/ssrs-reports" className="navbar__link">Portal+ Reports</DropdownItem>
                                                            <DropdownItem tag={NavLink} to="/ssrs-custom-reports" className="navbar__link">Portal+ Custom Reports</DropdownItem>
                                                            <DropdownItem disabled tag={NavLink} to="/crm-reports" className="navbar__link">CRM Reports</DropdownItem>
                                                            <DropdownItem disabled tag={NavLink} to="/custom-crm-reports" className="navbar__link">CRM Custom Reports</DropdownItem>
                                                        </>
                                                    )}
                                                    {showSECReports && <DropdownItem tag={NavLink} to="/reports" className="navbar__link">Reporting</DropdownItem>}
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        );
                                    }}
                                </CRMContext.Consumer>

                                <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret style={{ textTransform: 'capitalize' }} className="navbar__link">
                                        {nickname}
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-right-fix">
                                        <DropdownItem tag={NavLink} to="/profile" className="navbar__link">My Profile</DropdownItem>
                                        <PermissionWrapper {...this.props} allowedPermission={["Admin"]} hidden={true}>
                                            <DropdownItem tag={NavLink} to="/admin" className="navbar__link">Users, Roles & Permissions</DropdownItem>
                                        </PermissionWrapper>
                                        <DropdownItem tag={NavLink} to="/dashboard-tiles" className="navbar__link">Dashboard Tiles</DropdownItem>
                                        <PermissionWrapper {...this.props} allowedPermission={["Utilities"]} hidden={true}>
                                            <DropdownItem tag={NavLink} to="/utilities" className="navbar__link">Utilities</DropdownItem>
                                        </PermissionWrapper>
                                        <PermissionWrapper {...this.props} allowedPermission={["System Configuration"]} hidden={true}>
                                            <DropdownItem tag={NavLink} to="/system-configuration" className="navbar__link">System Configuration</DropdownItem>
                                        </PermissionWrapper>
                                        {this.props.companies.length > 1 &&
                                            <DropdownItem onClick={this.props.resetCompany} className="navbar__link">Change Company</DropdownItem>}
                                        <DropdownItem divider />
                                        <AuthenticationButton />
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </>
                        )}
                    </div>
                </Nav>

                {/* ROUTES ARE ALWAYS MOUNTED */}
                <Switch>
                    <Route exact path="/" render={this.renderLanding} />
                    {/* <Route exact path="/callback" render={this.renderLanding} /> */}

                    {ready ? (
                        <>
                            <ProtectedRoute path="/demographics/:sec?" render={(p) =>
                                <PermissionWrapper {...p} {...this.props} allowedPermission="">
                                    <Demographics key={p.match.params.sec || 'index'} checkPermission={this.checkPermission} {...p} {...this.props} />
                                </PermissionWrapper>
                            } />
                            <ProtectedRoute path="/compare-demographics" render={(p) => <CompareDemographics {...p} {...this.props} />} />
                            <ProtectedRoute path="/master-child-demographics" render={(p) => <MasterChildDemographics {...p} {...this.props} />} />
                            {useSECData && <ProtectedRoute path="/business-demographics" render={(p) => <BusinessDemographics {...p} {...this.props} />} />}
                            <ProtectedRoute exact path="/search" render={(p) =>
                                <PermissionWrapper {...p} {...this.props} allowedPermission="">
                                    <AdvancedSearch {...p} {...this.props} />
                                </PermissionWrapper>
                            } />
                            <CRMContext.Consumer>
                                {crmCtx => crmCtx?.crmEnabled === true && (
                                    <>
                                        <ProtectedRoute exact path="/ssrs-reports" render={(p) => <SSRSReports {...p} {...this.props} companySettings={this.state.companySettings} title="Portal+ Reports" includeStandard={true} includeCustom={false} />} />
                                        <ProtectedRoute exact path="/ssrs-custom-reports" render={(p) => <SSRSReports {...p} {...this.props} companySettings={this.state.companySettings} title="Custom Portal+ Reports" includeStandard={false} includeCustom={true} />} />
                                    </>
                                )}
                            </CRMContext.Consumer>
                            <ProtectedRoute exact path="/crm-reports" render={(p) => <CRMReports {...p} {...this.props} companySettings={this.state.companySettings} />} />
                            <ProtectedRoute exact path="/custom-crm-reports" render={(p) => <CRMCustomReports {...p} {...this.props} companySettings={this.state.companySettings} />} />
                            {this.state.companySettings?.CompanyUseSECData && (
                                <ProtectedRoute exact path="/reports" render={(p) => <SECReports {...p} {...this.props} companySettings={this.state.companySettings} />} />
                            )}
                            {this.state.companySettings?.CompanyUseSECData && (
                                <ProtectedRoute path="/reports/" render={(p) => <SECReportsDetail {...p} {...this.props} />} />
                            )}
                            <ProtectedRoute exact path="/marketing" render={(p) => <Marketing2 checkPermission={this.checkPermission} {...p} {...this.props} />} />
                            <ProtectedRoute path="/companies" render={this.renderCompanies} />
                            <ProtectedRoute path="/contacts/:id?" render={(p) => <Contacts2 {...p} {...this.props} companySettings={this.state.companySettings} />} />
                            {this.state.opportunitiesTags?.map(opportunityTag => (
                                <ProtectedRoute key={opportunityTag} exact path={`/${opportunityTag.toLowerCase().replaceAll(' ', '-')}`} render={(p) =>
                                    <SalesOpportunitiesAdmin {...p} {...this.props} type={opportunityTag} />
                                } />
                            ))}
                            <ProtectedRoute exact path="/utilities" render={(p) => <Utilities checkPermission={this.checkPermission} {...p} {...this.props} />} />
                            <ProtectedRoute exact path="/system-configuration" render={(p) => <SystemConfiguration checkPermission={this.checkPermission} {...p} {...this.props} getCompanySettings={this.getCompanySettings} />} />
                            <ProtectedRoute exact path="/dashboard-tiles" render={(p) => <DashboardTiles {...p} {...this.props} />} />
                            <ProtectedRoute exact path="/admin" render={(p) => <Admin {...p} {...this.props} />} />
                            <ProtectedRoute exact path="/profile" render={(p) => <Profile {...p} {...this.props} />} />
                            {/* all other protected routes */}
                        </>
                    ) : (
                        // <Route render={() => <div className="App">Loading user data…</div>} />
                        <Route
                            render={() =>
                                pathname === "/callback"
                                    ? null
                                    : <div className="App">Loading user data…</div>
                            }
                        />
                    )}
                </Switch>
            </>
        );
    }
}

export default withRouter(withAuth0(NavMenu));
